import { render, staticRenderFns } from "./EnrolmentOrganisation.vue?vue&type=template&id=0456af95&"
import script from "./EnrolmentOrganisation.vue?vue&type=script&lang=js&"
export * from "./EnrolmentOrganisation.vue?vue&type=script&lang=js&"
import style0 from "./EnrolmentOrganisation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports